import React, { useEffect, useState } from "react";
import {
  Menu,
  MenuItem,
  Badge,
  IconButton,
  Avatar,
  Typography,
  Stack,
  Divider,
  useTheme,
} from "@mui/material";
import dayjs from "dayjs";
import { Notifications } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../utils/config/config";

const NotificationsMenu = () => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [notifications, setNotifications] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const fetchNotifications = async () => {
    try {
      const response = await axiosInstance.get(
        "/notification/getAllNotifications"
      );

      setNotifications(response.data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchNotifications();
  }, []);

  const markAsRead = async (id) => {
    try {
      const response = await axiosInstance.get(
        `notification/markAsRead/${id}`,
        {
          notificationId: id,
        }
      );
      fetchNotifications();

      if (response.status === 200) {
        // dispatch(getAllNotifications());
      }
    } catch (error) {
      console.log(error);
    }
  };

  const markAllAsRead = async () => {
    try {
      const response = await axiosInstance.get("/notifications/markAllAsRead");

      if (response.status === 200) {
        fetchNotifications();
      }
    } catch (error) {
      console.log(error);
    } finally {
      handleClose();
    }
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        color="inherit"
        sx={{
          height: "50px",
          width: "50px",
        }}
      >
        <Badge
          badgeContent={
            notifications?.filter((notif) => !notif?.isRead)?.length
          }
          color="error"
        >
          <Notifications sx={{ color: "#E31C25" }} />
        </Badge>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            width: 450,
            maxHeight: 400,
            overflowY: "auto",
            borderRadius: 2,
            boxShadow: 3,
            p: 1,
          },
        }}
      >
        <Stack direction="row" alignItems="center">
          <Typography
            sx={{ px: 2, fontFamily: "Cinzel-Bold", fontSize: "18px", pb: 1 }}
          >
            Notifications
          </Typography>

          <Typography
            sx={{
              px: 2,
              fontFamily: "Cinzel-Regular",
              fontSize: "14px",
              pb: 1,
              ml: "auto",
              color: theme.palette.text.primary,
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={markAllAsRead}
          >
            Mark all as read
          </Typography>
        </Stack>
        <Divider />

        {notifications && notifications?.length === 0 ? (
          <MenuItem>No new notifications</MenuItem>
        ) : (
          notifications?.map((notif) => (
            <MenuItem
              key={notif.id}
              onClick={() => {
                markAsRead(notif?.id);
                handleClose();
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                backgroundColor: notif?.isRead ? "transparent" : "#7a7a7a",
                borderRadius: 1,
                marginBottom: 1,
                p: 1.5,
                mt: 1,
              }}
            >
              {/* <Avatar src={notif.image} alt="User" /> */}
              <Stack>
                <Typography style={{ fontFamily: "Calibri-Bold" }}>
                  {notif?.type}
                </Typography>
                <Typography style={{ fontFamily: "Calibri-Regular" }}>
                  {notif?.message}
                </Typography>
                <Typography style={theme.body2}>
                  {dayjs(notif?.createdAt).format("MM/DD/YYYY")}
                </Typography>
              </Stack>
            </MenuItem>
          ))
        )}
      </Menu>
    </>
  );
};

export default NotificationsMenu;
